import { render, staticRenderFns } from "./annualPackage.vue?vue&type=template&id=656b0c4a&scoped=true"
import script from "./annualPackage.vue?vue&type=script&lang=js"
export * from "./annualPackage.vue?vue&type=script&lang=js"
import style0 from "./annualPackage.vue?vue&type=style&index=0&id=656b0c4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656b0c4a",
  null
  
)

export default component.exports